import apiService from "./apiService";
import AppConstants from "../appConstants";

class AcceptorLogsService {
    findAll(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_ACCEPTOR_LOGS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
    // =====================================================================
    
}

export default new AcceptorLogsService();
